import { render } from "./FueraDePeriodo.vue?vue&type=template&id=509ce617&scoped=true"
import script from "./FueraDePeriodo.vue?vue&type=script&lang=js"
export * from "./FueraDePeriodo.vue?vue&type=script&lang=js"

import "./FueraDePeriodo.vue?vue&type=style&index=0&id=509ce617&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509ce617"]])

export default __exports__